import { ThemedStyledProps as _ThemedStyledProps } from "styled-components";
import { FlattenInterpolation as _FlattenInterpolation } from "styled-components";
import { css as _css } from "styled-components";
import { getElevations, getRadius, media } from "@wantedly_private/ui-foundation";
import { combineStyles } from "./combineStyles";
export var resetCss = _css(["box-sizing:border-box;padding:0;margin:0;background:none;border:none;outline:none;"]);
export var elevationCss = _css(function (p) {
  if (p.elevation === null) return null;
  return "box-shadow: ".concat(getElevations(p.elevation).join(","), ";");
});
export var shapeCss = _css(function (p) {
  if (p.shape === null) return null;
  return "border-radius: ".concat(getRadius(p.shape), ";");
});
export var textStyleCss = _css(function (p) {
  if (p.textStyle === null) return null;

  if (p.$device === "mobile") {
    return deviceFontStyle(p.textStyle.mobile);
  } else if (p.$device === "tablet" || p.$device === "laptop" || p.$device === "laptopL") {
    return deviceFontStyle(p.textStyle.laptop);
  }

  return "\n  ".concat(deviceFontStyle(p.textStyle.laptop), "\n\n  @media ").concat(media.mobile, " {\n    ").concat(deviceFontStyle(p.textStyle.mobile), "\n  }\n");
});

function deviceFontStyle(deviceStyle) {
  return "\n    font-family: ".concat(deviceStyle.fontFamily, ";\n    font-size: ").concat(deviceStyle.fontSize, "px;\n    font-weight: ").concat(deviceStyle.fontWeight, ";\n    line-height: ").concat(deviceStyle.lineHeight, "px;\n    ").concat(deviceStyle.letterSpacing && "letter-spacing: ".concat(deviceStyle.letterSpacing, "px;"), "\n\n    :lang(en), .text-narrow {\n      font-size: ").concat(deviceStyle.fontSize, "px;\n      font-weight: ").concat(deviceStyle.fontWeight, ";\n    }\n\n    :lang(ja), .text-wide {\n      font-size: ").concat(deviceStyle.fontSizeJa, "px;\n      font-weight: ").concat(deviceStyle.fontWeightJa, ";\n    }\n");
}

export var reactionCss = _css(function (p) {
  if (p.reaction === null) return null;
  return "\n  background-image: ".concat(p.reaction.backgroundImage, ";\n  box-shadow: ").concat(p.reaction.boxShadow, ";\n");
});
export var foundationCss = combineStyles(resetCss, elevationCss, shapeCss, textStyleCss, reactionCss);
//# sourceMappingURL=styles.js.map